import Forward from "@mui/icons-material/Forward";
import Money from "@mui/icons-material/Money";
import Pause from "@mui/icons-material/Pause";
import Payments from "@mui/icons-material/Payments";
import PointOfSale from "@mui/icons-material/PointOfSale";
import SupportAgent from "@mui/icons-material/SupportAgent";
import { DateTime } from "luxon";

/**
 * @type {Record<import("@seabrookstudios/pitch2table-core").RoyaltyType, import("@mui/material/OverridableComponent").OverridableComponent<import("@mui/material").SvgIconTypeMap<{}, "svg">> & { muiName: string; }>}
 */
export const RoyaltyTypeIcons = {
  Royalty: Money,
  Advance: Forward,
  HoldingFee: Pause,
  SigningBonus: PointOfSale,
  Consulting: SupportAgent,
  Other: Payments,
};

/**
 * @param {import("luxon").DateTime} current
 * @param {import("@seabrookstudios/pitch2table-core").CycleType} cycleType
 * @returns {import("luxon").DateTime}
 */
const advance = (current, cycleType) => {
  switch (cycleType) {
    case "monthly":
      return current.plus({ months: 1 });
    case "quarterly":
      return current.plus({ months: 3 });
    case "twice-yearly":
      return current.plus({ months: 6 });
    case "yearly":
      return current.plus({ years: 1 });
    default:
      return current.plus({ months: 1 });
  }
};

/**
 * @param {number|undefined} startDate
 * @param {import("@seabrookstudios/pitch2table-core").CycleType} cycleType
 */
export const getNextOccurrenceDate = (startDate, cycleType) => {
  if (!startDate) {
    return undefined;
  }

  const now = DateTime.now();
  const nextDate = DateTime.fromMillis(startDate);
  if (nextDate.toMillis() >= now.toMillis()) {
    return nextDate.toMillis();
  }

  return advance(nextDate, cycleType).toMillis();
};
